import {
    SkyNetTableConfig, SkyNetTableField, injectFieldsToTabs,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    InvoicesTableTabs,
} from 'app/enums/domain.enums'
import {
    InvoiceDesignation, OrderStatuses, InvoiceStatus,
} from 'app/enums/label.enums'

type OrderInvoicesView = {
    orderNumber: string,
    orderStatus: string,
    hasBillingCompleted: boolean,
    billingCompanyLocationName: string,
    customerLocationName: string,
    from: string,
    to: string,
    requestedHandover: string,
    accountCompanyCompanyName: string,
    outgoingInvoicesDetails: {
        invoiceDesignation: InvoiceDesignation,
        invoiceStatus: InvoiceStatus,
    }[],
    billedAmount: number,
}

type OrderInvoicesViewFields = keyof OrderInvoicesView

export default ({
    theme,
}): SkyNetTableConfig<OrderInvoicesViewFields> => {
    const fields: SkyNetTableField<OrderInvoicesViewFields>[] = [
        {
            name: 'orderNumber',
            reduced: true,
            labelKey: 'ORDER',
        },
        {
            name: 'orderStatus',
            filterField: 'orderStatus',
            filterType: FilterType.Array,
            componentName: 'EnumValue',
            allowedValuesEnum: OrderStatuses,
            reduced: true,
            labelKey: 'ORDER_STATUS',
        },
        {
            name: 'hasBillingCompleted',
            componentName: 'ChipCheckMark',
            labelKey: 'BILLING_COMPLETED',
        },
        {
            name: 'billingCompanyLocationName',
            filterField: 'billingCompanyLocationName',
            filterType: FilterType.Array,
            reduced: true,
            labelKey: 'BILLING_COMPANY',
        },
        {
            name: 'customerLocationName',
            filterField: 'customerLocationName',
            filterType: FilterType.Array,
            labelKey: 'CUSTOMER',
        },
        {
            name: 'accountCompanyCompanyName',
            filterField: 'accountCompanyCompanyName',
            filterType: FilterType.Array,
            labelKey: 'ACCOUNT',
        },
        {
            name: 'requestedHandover',
            filterField: 'requestedHandover',
            filterType: FilterType.DateRange,
            componentName: 'DateTimeCell',
            labelKey: 'REQUESTED_HANDOVER',
        },
        {
            name: 'from',
            filterField: 'from',
            filterType: FilterType.Array,
            labelKey: 'FROM',
        },
        {
            name: 'to',
            filterField: 'to',
            filterType: FilterType.Array,
            labelKey: 'TO',
        },
        {
            name: 'outgoingInvoicesDetails',
            labelKey: 'INVOICES',
            componentName: 'EnumListMultipleColored',
            enumsConfig: [
                {
                    name: 'invoiceStatus',
                    allowedValuesEnum: InvoiceStatus,
                    colorConfig: {
                        [InvoiceStatus.CREATED]: theme?.palette.common.lightYellow,
                        [InvoiceStatus.PAID]: theme?.palette.common.green,
                        [InvoiceStatus.SENTTOSAP]: theme?.palette.common.yellow,
                        [InvoiceStatus.SENTTOBILLINGCOMPANY]: theme?.palette.primary.main,
                    },
                    renderAs: 'tooltip',
                },
                {
                    name: 'invoiceDesignation',
                    allowedValuesEnum: InvoiceDesignation,
                    renderAs: 'chip',
                },
            ],
            sorting: false,
        },
        {
            name: 'billedAmount',
            sorting: false,
            labelKey: 'BILLED_AMOUNT',
        },
    ]

    return {
        name: 'InvoicesTable',
        tabs: injectFieldsToTabs<OrderInvoicesViewFields>([
            {
                name: 'All Orders',
                url: CommonRoutes.All,
                requestUrl: 'customer-transport',
            },
            {
                name: 'BL Created',
                url: InvoicesTableTabs.BaseLeaseCreated,
            },
            {
                name: 'ED To Be Created',
                url: InvoicesTableTabs.ExtraDaysToBeCreated,
            },
            {
                name: 'ED Created',
                url: InvoicesTableTabs.ExtraDaysCreated,
            },
            {
                name: 'CA To Be Created',
                url: InvoicesTableTabs.CancelledBilling,
            },
            {
                name: 'Billing Completed',
                url: InvoicesTableTabs.BillingCompleted,
            },
            {
                name: 'Manual Review',
                url: InvoicesTableTabs.RequiredManualBillingReview,
            },
            {
                name: 'Not Synced Billing Company',
                requestUrl: 'customer-transport',
                includeFilters: {
                    billingBillingCompanyIsSyncedWithAbacus: [false],
                },
                url: InvoicesTableTabs.NotSyncedBillingCompany,
            },
            {
                name: 'Billing Not Completed',
                requestUrl: 'customer-transport',
                includeFilters: {
                    hasBillingCompleted: [false],
                },
                url: InvoicesTableTabs.BillingNotCompleted,
            },
        ], fields),
    }
}
